import { DateTime } from "luxon";

export const PHONE_CONFIG_STATUSES = {
  VERIFIED: "verified",
  UNVERIFIED: "unverified",
  SUBMITTED: "submitted",
  FAILED: "failed",
  IN_REVIEW: "in-review",
  IGNORE: "ignore",
  PENDING: "pending"
};

export const isGracePeriodAfterNow = phoneConfig => {
  return DateTime.fromJSDate(phoneConfig?.gracePeriod?.toDate()).diffNow("minute").minutes > 0;
};
